import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loginReset } from "redux/slice/authentication";

export interface BrokerSettingsState {
	isEnhancedBioEnabled: boolean;
	bioPageLayout: string;
}

const initialState: BrokerSettingsState = {
	isEnhancedBioEnabled: false,
	bioPageLayout: "layout1",
};

export const brokerSettingsSlice = createSlice({
	name: "brokerSettings",
	initialState,
	reducers: {
		setEnhancedBioEnabled: (state, action: PayloadAction<boolean>) => {
			state.isEnhancedBioEnabled = action.payload;
		},
		setBioPageLayout: (state, action: PayloadAction<string>) => {
			state.bioPageLayout = action.payload;
		},
		resetBrokerSettings: () => {
			return initialState;
		},
	},
	extraReducers(builder) {
		// Reset broker settings when user logs out
		builder.addCase(loginReset, () => {
			return initialState;
		});
	},
});

export const { setEnhancedBioEnabled, setBioPageLayout, resetBrokerSettings } = brokerSettingsSlice.actions;
